import PlayerListTable from "../tables/PlayerListTable";
import StaffListTable from "../tables/StaffListTable";
import TeamListTable from "../tables/TeamListTable";

import { playerStore } from "../store/PlayerStore";
import { staffStore } from "../store/StaffStore";
import { teamStore } from "../store/TeamStore";

export const SELECTION_MODE = {
    PLAYER: "player",
    STAFF: "staff",
    CORE_SQUAD: "core_squad",
    EXTENDED_SQUAD: "extended_squad",
};

export const selectionRegistry = {
    [SELECTION_MODE.PLAYER]: {
        store: playerStore,
        Table: PlayerListTable,
        init: (
            store,
            resourceStore,
            allPositions,
            teamId,
            numberOfStartingPlayers,
        ) => {
            store.setInitialData(
                resourceStore.data.allMatchPlayers,
                allPositions,
                teamId,
                numberOfStartingPlayers,
                resourceStore,
            );
        },
        getPreSelectedItems: (store, teamId) =>
            store.allPlayers
                .filter((p) => p.team === teamId && !p.isDeleted)
                .map((p) => ({ id: p.contact })),
    },
    [SELECTION_MODE.STAFF]: {
        store: staffStore,
        Table: StaffListTable,
        init: (
            store,
            resourceStore,
            _allPositions,
            teamId,
            _numberOfStartingPlayers,
        ) => {
            store.setInitialData(
                resourceStore.data.allMatchStaff,
                teamId,
                resourceStore,
            );
        },
        getPreSelectedItems: (store, teamId) =>
            Object.values(store?.allPlayers)
                .filter((p) => p.dhbTeam === teamId && !p.isDeleted)
                .map((p) => ({ id: p.contact })),
    },
    [SELECTION_MODE.CORE_SQUAD]: {
        store: teamStore,
        Table: TeamListTable,
        init: (store, resourceStore, allPositions, teamId) => {
            store.setInitialData(
                resourceStore.data.allTeamPlayers,
                allPositions,
                teamId,
                resourceStore,
            );
        },
        getPreSelectedItems: (store, teamId) =>
            Object.values(store.allPlayers)
                .filter(
                    (p) => p.team === teamId && !p.isDeleted && p.core === true,
                )
                .map((p) => ({ id: p.contact })),
    },
    [SELECTION_MODE.EXTENDED_SQUAD]: {
        store: teamStore,
        Table: TeamListTable,
        init: (store, resourceStore, allPositions, teamId) => {
            store.setInitialData(
                resourceStore.data.allTeamPlayers,
                allPositions,
                teamId,
                resourceStore,
            );
        },
        getPreSelectedItems: (store, teamId) =>
            Object.values(store.allPlayers)
                .filter(
                    (p) =>
                        p.team === teamId && !p.isDeleted && p.core === false,
                )
                .map((p) => ({ id: p.contact })),
    },
};
